import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

export async function getStates() {
  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const response = {
    data: states,
  };
  return response.data;
}

export async function getNoteTemplates(locationId) {
  const tenantId = getAccountId();
  const response = await api.get(`/patients/${tenantId}/note-template/`, {
    params: {
      location: locationId,
    },
  });
  return response.data;
}

export async function addNoteTemplate(body, locationId) {
  const tenantId = getAccountId();
  const response = await api.post(`/patients/${tenantId}/note-template/`, {
    ...body,
    location: locationId,
  });
  return response.data;
}

export async function deleteNoteTemplate(noteTemplateId, locationId) {
  const tenantId = getAccountId();
  const response = await api.delete(
    `/patients/${tenantId}/note-template/${noteTemplateId}/`,
    {
      params: {
        location: locationId,
      },
    }
  );
  return response.data;
}

export async function updateNoteTemplate(noteTemplateId, body, locationId) {
  const tenantId = getAccountId();
  const response = await api.patch(
    `/patients/${tenantId}/note-template/${noteTemplateId}/`,
    body,
    {
      params: {
        location: locationId,
      },
    }
  );
  return response.data;
}
